module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4vF8O"))).then(() => parcelRequire('cvs7o'));